import { CardsDiamondIcon } from './CardsDiamondIcon';

/**
 * author: Nick
 * id 0934FB0D-8585-4064-989F-054E52D16FDB
 * name cards-diamond
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-diamond.svg
 * tags
 * - Gaming / RPG 
 * - Transportation + Road 
 */
export const SuitDiamondsIcon = CardsDiamondIcon;
export default SuitDiamondsIcon